import { Box, Flex, Link } from "@chakra-ui/react";
import { UploadedFile } from "newui/components/FileUpload";
import { useState } from "react";
import { MessageFileCard } from "./MessageFileCard";
import { FileableFile } from "types/storage.types";

interface MessageFileListProps {
	files: FileableFile[];
}

export const MessageFileList: React.FC<MessageFileListProps> = ({ files }) => {
	const [expanded, setExpanded] = useState(false);
	const INITIAL_DISPLAY_COUNT = 2;

	if (!files || files.length === 0) return null;

	const displayFiles = expanded ? files : files.slice(0, INITIAL_DISPLAY_COUNT);
	const hasMore = files.length > INITIAL_DISPLAY_COUNT;

	return (
		<Box
			mt={2}
			mb={1}
		>
			<Flex
				direction="column"
				gap={2}
			>
				{displayFiles.map((file) => (
					<MessageFileCard
						key={file.id}
						file={file}
					/>
				))}
			</Flex>

			{hasMore && !expanded && (
				<Link
					fontSize="sm"
					color="blue.600"
					fontWeight="medium"
					mt={2}
					display="inline-block"
					onClick={(e) => {
						e.preventDefault();
						setExpanded(true);
					}}
					cursor="pointer"
					_hover={{ textDecoration: "underline" }}
				>
					View {files.length - INITIAL_DISPLAY_COUNT} more file
					{files.length - INITIAL_DISPLAY_COUNT !== 1 ? "s" : ""}...
				</Link>
			)}

			{expanded && hasMore && (
				<Link
					fontSize="sm"
					color="blue.600"
					fontWeight="medium"
					mt={2}
					display="inline-block"
					onClick={(e) => {
						e.preventDefault();
						setExpanded(false);
					}}
					cursor="pointer"
					_hover={{ textDecoration: "underline" }}
				>
					Show less
				</Link>
			)}
		</Box>
	);
};
